import DynamicSectionElement from '@/js/dynamic-section-element';
import { dispatchCartClickEventListener } from '@/js/utils/cart-utilities.js';

class CartIcon extends DynamicSectionElement {
  constructor() {
    super();

    dispatchCartClickEventListener(this);
  }

  connectedCallback() {
    this.initVariables();
  }

  initVariables() {
    this.countElement = this.querySelector('[data-cart-items-count]');
  }

  setCount(value) {
    this.countElement.dataset.cartItemsCount = value;
  }

  afterSectionRender() {
    this.initVariables();
  }
}

customElements.get('cart-icon') || customElements.define('cart-icon', CartIcon);
